import Modal from "./modal_controller"
import CookiesManager from "./../utils/CookiesManager"

export default class extends Modal {

    static targets = [
    ]

    initialize(){
        super.initialize()
    }

    maybeStartOpen(){
        if ( !CookiesManager.readCookie(`modal-${this.name}-closed`) ) {
            console.log("open now")
            super.maybeStartOpen()
        }
    }

    beforeOpened(e) {
    }

    afterClosed(e) {
        //CookiesManager.createCookie(`modal-${this.name}-closed`, 1, parseInt(this.data.get("cookieDuration")))
    }

}